import collectTimes from "@/components/garbage/collectTimes";
import bucket from "@/components/garbage/bucket";
import toilet from "@/components/garbage/toilet";
import landmark from "@/components/garbage/landmark";
import siteCollect from "@/components/garbage/siteCollect";
import siteTransfer from "@/components/garbage/siteTransfer";
import ljqyzl from "@/components/garbage/ljqyzl";
import ljqycx from "@/components/garbage/ljqycx";
import zyxl from "@/components/carsys/zyxl";
import lajiqingyun from "@/components/garbage/zyxl";
var data = [
    {
        path: "/collectTimes",
        component: collectTimes
      },
      {
        path: "/bucket",
        component: bucket
      },
      {
        path: "/landmark",
        component: landmark
      },
      {
        path: "/siteCollect",
        component: siteCollect
      },
      {
        path: "/siteTransfer",
        component: siteTransfer
      },
      {
        path: "/toilet",
        component: toilet
      }
      , {
        path: "/lajiqingyun",
        component: lajiqingyun
      }, {
        path: "/zyxl",
        component: zyxl
      },
      {
        path: "/ljqyzl",
        component: ljqyzl
      },
      {
        path: "/ljqycx",
        component: ljqycx
      },
];
export default data;



// WEBPACK FOOTER //
// ./src/router/qingyun.js